import {
  faArrowsRotate,
  faCheckCircle,
  faXmarkCircle
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Row } from "antd";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import LoadingAction from "../../../themes/LoadingAction/LoadingAction";
import * as links from "../../../utils/links";
import "./Dashboard.css";
import NewVersionAlertModal from "../NewVersionAlert/modal";

const DashboardFornecedor = (props) => {
  const { setDataUser, loading, authInfo, setNotiMessage } =
    useContext(AuthContext);
  
  const { dataUser } = authInfo;
  let navigate = useNavigate();
  const token = authInfo?.dataUser?.token;
  const premiumExpiration = authInfo?.dataUser?.premiumExpiration ?? null;
  const hasData = !!authInfo?.dataUser?.hasData;
  const [favorites, setFavorites] = useState([]);
  const [meusFits, setMeusFits] = useState(null);
  const [totalCanais, setTotalCanais] = useState(null);
  const [totalFornecedores, setTotalFornecedores] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [dataCurrentDetail, setDataCurrentDetail] = useState(null);

  // useEffect(() => {
  //     dataData();
  // }, [])

  useEffect(() => {
    dataData();

    const intervalId = setInterval(() => {
      dataData();
    }, 60000);

    // Limpar o intervalo quando o componente for desmontado para evitar vazamento de memória
    return () => clearInterval(intervalId);
  }, []);

  const dataData = () => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_SERVIDOR}/maquinas`, {
        headers: {
          "x-access-token": token,
          "content-type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          setIsLoading(false);
          setTotalFornecedores(res.data);
        } else {
          throw new Error();
        }
      })
      .catch((err) => {
        setIsLoading(false);
        if ([401, 403].includes(err.response.status)) {
          // setNotiMessage('A sua sessão expirou, para continuar faça login novamente.');
          setNotiMessage({
            type: "error",
            message:
              "A sua sessão expirou, para continuar faça login novamente.",
          });
          if (dataUser.key === 'ADMIN') {
            navigate(links.ADMIN_SIGNIN)
            setDataUser(null);
          } else {
            navigate(links.SIGNIN)
            setDataUser(null);
          }
        }
      });
  };

  const handleMaquinaClick = (maquinaInfos) => {
    navigate(`${links.FORNECEDOR_SEARCH_CANAIS}/${maquinaInfos.id}`, {
      state: {maquinaInfos},
    });
  };

  return (
    <div className="Dashboard_container">
      {isLoading && <LoadingAction />}
      {/* <div className="WarningMsg">
                    {dataUser.warningMsg}
                </div> */}
      {
        dataUser.warningMsg && (
          <div className="WarningMsgSpan">
            <span>
              Seu plano está bloqueado, acesse{' '}
              <Link to={links.CLIENTE_MENSALIDADES} className="underline-link">
                Minhas Mensalidades
              </Link>{' '}
              para renovar.
            </span>
          </div>
        )
      }
      <div className="Dashboard_header">
        <div className="Dashboard_staBlockTitle">Monitoramento</div>
      </div>
      <div className="Dashboard_action">
        <Button style={{ margin: "0 15px" }} onClick={dataData}>
          <FontAwesomeIcon
            icon={faArrowsRotate}
            style={{ marginRight: "5px" }}
          />
          Atualizar
        </Button>
        <Link to={links.ADD_MACHINE}>
          <Button className="Dashboard_addbtn">
            <AiOutlinePlusCircle />
            <span>Adicionar Máquina</span>
          </Button>
        </Link>
      </div>
      <NewVersionAlertModal />
      <Row>
        {totalFornecedores.map((post) => (
          <Col xs={24} md={24} lg={8} xl={8} className="Dashboard_col">
            <div
              className="maquina"
              key={post.id}
              onClick={() =>
                handleMaquinaClick(
                  post
                )
              }
            >
              <div className="maquina-info">
                {(() => {
                  switch (post.status) {
                    case "ONLINE":
                      return (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <FontAwesomeIcon
                            icon={faCheckCircle}
                            color={"green"}
                            className="logout-icon fa-3x"
                          />
                          <b>{post.nivelDeSinal ? `${post.nivelDeSinal}%` : null}</b>
                        </div>
                      );
                    case "OFFLINE":
                      return (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <FontAwesomeIcon
                            icon={faXmarkCircle}
                            color={"red"}
                            className="logout-icon fa-3x"
                          />
                          {
                            <OverlayTrigger
                              key={post.id}
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-top-${post.id}`}>
                                  {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                </Tooltip>
                              }>
                              <i className="bi bi-reception-0" style={{ fontSize: '42px', color: 'transparent' }}></i>
                            </OverlayTrigger>
                          }
                        </div>
                      );
                    case "PAGAMENTO_RECENTE":
                      return (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <FontAwesomeIcon
                            icon={faCheckCircle}
                            color={"blue"}
                            className="logout-icon fa-3x"
                          />
                          <b>{post.nivelDeSinal ? `${post.nivelDeSinal}%` : null}</b>
                        </div>
                      );
                    default:
                      return null;
                  }
                })()}
                <h2>{post.nome}</h2>
                <h6 style={{ fontWeight: "300" }}>
                  {post.status} - {post.descricao}
                </h6>
                <h6 style={{ fontWeight: "300" }}>MP: {post.store_id}</h6>
                <h6 style={{ fontWeight: "300" }}>PAG: {post.maquininha_serial}</h6>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default DashboardFornecedor;
